export const filterEnabledCols = [
    "firstName",
    "middleName",
    "lastName",
    "email",
    "userStatus"
];
